import React from 'react';

import { Divider, Grid, useTheme } from '@mui/material';

import { TutorPlanOrderResumeCreditCard } from './TutorPlanOrderResumeCreditCard';
import { TutorPlanOrderResumeDiscount } from './TutorPlanOrderResumeDiscount';
import { TutorPlanOrderResumeDownloadApp } from './TutorPlanOrderResumeDownloadApp';
import { TutorPlanOrderResumeSubtotal } from './TutorPlanOrderResumeSubtotal';
import { TutorPlanOrderResumeSuccess } from './TutorPlanOrderResumeSuccess';
import { ITutorUserCreateOrContractPlanResponse } from 'types/TutorUser';

interface Props {
  resume: ITutorUserCreateOrContractPlanResponse | null;
}

export const TutorPlanOrderResume: React.FC<Props> = ({ resume }) => {
  const {
    palette: { primary },
  } = useTheme();

  if (!resume) {
    return null;
  }

  const { creditCard, plan, tutorPlan } = resume;

  return (
    <Grid p={2} spacing={2}>
      <TutorPlanOrderResumeSuccess />

      <Divider sx={{ my: 4, backgroundColor: primary.main }} />

      <Grid item container xs={12} lg={12} spacing={2} justifyContent="center">
        <TutorPlanOrderResumeCreditCard
          creditCardTitle={creditCard?.title}
          creditCardDescription={creditCard?.description}
          planPrice={plan?.price}
          planTitle={plan?.title}
          installmentText={plan.installmentText}
        />

        <Grid item mx={1}>
          <Divider
            orientation="vertical"
            sx={{ backgroundColor: primary.main }}
          />
        </Grid>

        <TutorPlanOrderResumeSubtotal
          discountValue={tutorPlan?.ticketValues?.formated?.discountValue}
          finalValue={tutorPlan?.ticketValues?.formated?.formatedFinalValue}
          planPrice={plan?.price}
        />

        <TutorPlanOrderResumeDiscount couponName={tutorPlan?.ticket?.name} />
      </Grid>

      <Divider sx={{ my: 4, backgroundColor: primary.main }} />

      <TutorPlanOrderResumeDownloadApp />
    </Grid>
  );
};
